import classNames from "classnames";

function numberToAngle(current, max) {
  if (max === 0) return 0; // prevent divide by zero
  //return 360 * (1 - (current / max));
  return 360 * (current / max);
}

export function CooldownAbility({ icon, data, cooldownDuration, type = "ability", sizing = 'h-[38px] w-[38px]' }) {

    let background = "url(/liveGameIcons/ability_background.png)"
    if (type == "military") {
        background = "url(/liveGameIcons/military_background.png)"
    }


    let angle = numberToAngle(data, cooldownDuration);
    return (
        <div className={classNames(sizing)} style={{"--angle": `${angle}deg`}}>
            <div className={classNames(sizing, 'absolute')}
                style={{
                    backgroundImage: background
                }}>
                <img src={icon} alt="" />
            </div>
            <div className="h-[40px] w-[40px] mask-clock bg-[#ffffff83] -z-10" style={{"--angle": `${angle}deg`}}></div>
        </div>
    )
}